module.exports = __webpack_public_path__ + "static/media/close-2.585b265f.svg";